import { Component, OnInit } from '@angular/core';
import { ToggleService } from '../toggle.service';

@Component({
  selector: 'app-mainpage',
  templateUrl: './mainpage.component.html',
  styleUrls: ['./mainpage.component.scss']
})
export class MainpageComponent  implements OnInit {
  constructor(private toggle: ToggleService) {}

  ngOnInit(): void {}

  get showComponent1(): boolean {
    return this.toggle.showComponent1;
  }

  get showComponent2(): boolean {
    return this.toggle.showComponent2;
  }

  toggleComponents() {
    this.toggle.toggleComponents();
  }
}
